import React from "react";
import UserProfile from "../Models/UserProfile";

const LoggedContext = React.createContext({
  username: "",
  tokenAPI: "",
  userPassword: "",
  userProfile: new UserProfile(),
  setUserToken: (UserName, TokenAPI) => {
    this.setState({ username: UserName, tokenAPI: TokenAPI });
  },
  setUserProfile: (user) => {
    this.setState({ userProfile: user });
  },
  setUserPassword: (item) => {
    this.setState({ userPassword: item });
  },
});

export const LoggedProvider = LoggedContext.Provider;
export const LoggedConsumer = LoggedContext.Consumer;
export default LoggedContext;
